<template>
    <div
        id="section-domains"
        class="personality-section">

        <div class="vertical-sep vertical-sep--top"></div>

        <h2 class="personality-section__title">{{ $t("ruler-location") }}</h2>

        <div class="page__subtitle page__subtitle--bubble--description">
            <transition name="fade">
                <div
                    v-show="currentTraitDescription"
                    v-html="currentTraitDescription"></div>
            </transition>
        </div>

        <div class="personality-section__content">
            <BubbleGraph
                v-if="bubbleGraphVisible"
                :data="data"
                :category="currentCategory"
                @open-trait="handleOpenTrait"
                @close-trait="handleCloseTrait"
            />
        </div>

        <div class="vertical-sep vertical-sep--bottom"></div>

    </div>
</template>

<script>
import Vue from "vue";

import BubbleGraph from "@/components/bubble-graph/BubbleGraph.vue";

import { slugify } from "@/utils/helpers/string.js";

export default {
    components: {
        BubbleGraph: BubbleGraph
    },

    props: {
        data: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            currentCategory: "house",
            bubbleGraphVisible: false,
            currentTrait: null
        };
    },

    computed: {
        currentTraitDescription() {
            if (this.currentTrait) {
                return this.$t(`${slugify(this.currentTrait)}-description`);
            }

            return null;
        }
    },

    mounted() {
        Vue.nextTick(() => {
            // Check if element is visible using IntersectionObserver
            // Should probably be polyfilled (https://caniuse.com/#search=IntersectionObserver)
            if ("IntersectionObserver" in window) {
                let lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
                    const entry = entries[0];

                    if (entry.isIntersecting) {
                        this.bubbleGraphVisible = true;
                    }
                }, {
                    threshold: 0.05,
                });

                // Increase POLL INTERVAL for polyfill
                // Fix issue on IOS Safari with intersection Observer not working only looking for dom-change and scroll
                // https://github.com/w3c/IntersectionObserver/tree/master/polyfill#configuring-the-polyfill
                lazyBackgroundObserver.POLL_INTERVAL = 100;

                lazyBackgroundObserver.observe(this.$el);
            }
        });
    },

    destroyed() {

    },


    methods: {
        handleOpenTrait(trait) {
            this.currentTrait = trait;
        },
        handleCloseTrait() {
            this.currentTrait = null;
        }
    },
};
</script>